/**
 * Offline State Module
 * Manages online/offline state for the application
 */

const state = {
  isOffline: false
};

const mutations = {
  SET_OFFLINE(state) {
    state.isOffline = true;
  },
  SET_ONLINE(state) {
    state.isOffline = false;
  }
};

const getters = {
  isOffline: (state) => state.isOffline
};

const actions = {
  setOffline({ commit }) {
    commit('SET_OFFLINE');
  },
  setOnline({ commit }) {
    commit('SET_ONLINE');
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};

